import { render, staticRenderFns } from "./Artwork.vue?vue&type=template&id=500492ce&scoped=true&"
import script from "./Artwork.vue?vue&type=script&lang=js&"
export * from "./Artwork.vue?vue&type=script&lang=js&"
import style0 from "./Artwork.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Artwork.vue?vue&type=style&index=1&id=500492ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500492ce",
  null
  
)

export default component.exports